/*
 * Copyright (c) 2024, King Living
 * Routes Configuration for Google Maps Integration
 */

import React from 'react';

import loadable from '@loadable/component';

import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config';
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui';
import {routes as baseRoutes} from '@salesforce/retail-react-app/app/routes';
import {configureRoutes} from '@salesforce/retail-react-app/app/utils/routes-utils';

const fallback = <Skeleton height="75vh" width="100%" />;

const Page = loadable(() => import('@amblique/contentful/app/pages/page'), {fallback});

// Import store pages with lazy loading
const StoreLocatorPage = loadable(() => import('./pages/stores/index'), {
  fallback,
});

const TestGeocodingPage = loadable(() => import('./pages/test-geocoding/index'), {
  fallback,
});

const StylingCheckPage = loadable(() => import('./pages/styling-check'), {
  fallback,
});

// Define custom routes
export const routes = [
  {
    path: '/showrooms',
    component: StoreLocatorPage,
    exact: true,
  },
  {
    path: '/showroom/:slug',
    component: Page,
  },
  {
    path: '/test-geocoding', // TODO: Remove this route after testing
    component: TestGeocodingPage,
    exact: true,
  },
  {
    path: '/styling-check',
    component: StylingCheckPage,
    exact: true,
  },

  ...baseRoutes
];

// Export routes function for PWA Kit
export default () => {
  const config = getConfig();

  return configureRoutes(routes, config, {
    ignoredRoutes: ['/callback', '/store-locator', '*'],
  });
};
